import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { FormTemplatesManager } from 'Src/components/FormTemplatesManager/FormTemplatesManager';

export const TournamentConfirmationRequests: React.FC<{ user: AppUser }> = ({ user }) => (
  <FormTemplatesManager
    user={user}
    types={['TOURNAMENT_CONFIRMATION']}
    title="Union form builder"
  />
);

